import { useEffect, useRef } from "react";

/* Subtle antique-gold halo that follows the pointer on desktop.
   - pointer:fine devices only (never on touch)
   - disabled entirely under prefers-reduced-motion
   - pointer-events: none — never interferes with clicks, selection or forms
   - the native cursor is untouched */
export const CursorHalo = () => {
    const ref = useRef(null);

    useEffect(() => {
        const fine = window.matchMedia("(pointer: fine)").matches;
        const reduced = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
        if (!fine || reduced || !ref.current) return;

        const el = ref.current;
        let raf = null;
        let tx = -100, ty = -100, x = -100, y = -100;
        let visible = false;

        const onMove = (e) => {
            tx = e.clientX;
            ty = e.clientY;
            if (!visible) {
                visible = true;
                el.style.opacity = "1";
            }
        };
        const onLeave = () => {
            visible = false;
            el.style.opacity = "0";
        };

        const tick = () => {
            x += (tx - x) * 0.12;
            y += (ty - y) * 0.12;
            el.style.transform = `translate3d(${x - 15}px, ${y - 15}px, 0)`;
            raf = requestAnimationFrame(tick);
        };

        window.addEventListener("pointermove", onMove, { passive: true });
        document.documentElement.addEventListener("pointerleave", onLeave);
        raf = requestAnimationFrame(tick);

        return () => {
            window.removeEventListener("pointermove", onMove);
            document.documentElement.removeEventListener("pointerleave", onLeave);
            if (raf) cancelAnimationFrame(raf);
        };
    }, []);

    return <div ref={ref} className="cursor-halo" aria-hidden="true" data-testid="cursor-halo" />;
};
